import { useEffect, useRef } from 'react';

/**
 * Runs a handler when an event starts outside the referenced element.
 * This keeps overlay behaviour owned by the application design system.
 */
const useOutsideEvent = (elementRef, eventName, handler, isEnabled = true) => {
	const handlerRef = useRef(handler);

	useEffect(() => {
		handlerRef.current = handler;
	}, [handler]);

	useEffect(() => {
		if (!isEnabled) return undefined;

		const handleEvent = (event) => {
			const element = elementRef.current;

			if (!element || element.contains(event.target)) return;

			handlerRef.current?.(event);
		};

		document.addEventListener(eventName, handleEvent);

		return () => document.removeEventListener(eventName, handleEvent);
	}, [elementRef, eventName, isEnabled]);
};

export default useOutsideEvent;
